import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { NotificationRepository } from "../../notification/notification.repository";
import { Notification } from "../../notification/notification.model";
import { NotifyService } from "../../notify/notify.service";
import { SafeHtmlPipe } from "../../shared/html/safe-html.pipe";
import { TimeAgoPipe } from "../../shared/time-ago/time-ago.pipe";

@Component({
  selector: "app-notification-dropdown",
  templateUrl: "./notification-dropdown.component.html",
  styleUrls: ["./notification-dropdown.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SafeHtmlPipe, TimeAgoPipe],
})
export class NotificationDropdownComponent implements OnInit {
  private eRef = inject(ElementRef);
  private notifyService = inject(NotifyService);
  private notificationRepository = inject(NotificationRepository);

  public notifications = [];
  public isVisible = false;

  @HostListener("document:click", ["$event"])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isVisible = false;
    }
  }

  ngOnInit() {
    this.checkNotifications();
  }

  public checkNotifications() {
    this.notificationRepository
      .getMyNotifications()
      .subscribe((notifications) => {
        this.notifications = notifications;
      });
  }

  public toggleMenu() {
    this.isVisible = !this.isVisible;
  }

  public openNotification(notification: Notification) {
    // The panel would otherwise stay open behind the alert dialog.
    this.isVisible = false;
    this.showNotification(notification);
    this.markAsRead(notification);
  }

  public getUnreadCount(): number {
    let count = 0;
    for (let i = 0; i < this.notifications.length; i++) {
      if (!this.notifications[i].isRead()) {
        count++;
      }
    }

    return count;
  }

  private showNotification(notification: Notification) {
    this.notifyService.alert(notification.body, notification.title);
  }

  private markAsRead(notification: Notification) {
    notification.setRead(true);
    this.notificationRepository
      .markAsRead(notification)
      .subscribe((removedNotification) => {
        notification.setRead(true);
      });
  }
}
